<template>
  <div class="customer">
    <!-- <sub-header /> -->

    <article class="sub-body res_wrap px-3">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">Customer / Partner</h3>
      </section>
      <section class="sub-body-content">

        <v-container fluid>
          <h4 class="sub-stitle text-h5 text-sm-h4 font-weight-medium h4-01">Partner</h4>
          <v-row class="align-stretch mt-4">
            <v-col cols="4" md="2" sm="3" class="d-flex align-stretch" v-for="(item, index) in cards" :key="index">
              <v-card class="d-flex align-center justify-center rounded-lg px-4 partner-logos pa" outlined width="100%">
                <img :src="item.src" />
              </v-card>
            </v-col>
          </v-row>

          <h4 class="sub-stitle text-h5 text-sm-h4 font-weight-medium h4-01 mt-15">Customer</h4>
          <v-row class="align-stretch mt-4">
            <v-col cols="4" md="2" sm="3" class="d-flex align-stretch" v-for="(item, index) in cards2" :key="index">
              <v-card class="d-flex align-center justify-center rounded-lg px-4 partner-logos cu" outlined width="100%">
                <img :src="item.src" />
              </v-card>
            </v-col>
          </v-row>
        </v-container>

      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'customer',
  data() {
    return {
      cards: [
        // { src: require("@/assets/logos_partner_01.svg"), },
        // { src: require("@/assets/logos_partner_02.svg"), },
        // { src: require("@/assets/logos_partner_03.svg"), },
        // { src: require("@/assets/logos_partner_04.svg"), },
        // { src: require("@/assets/logos_partner_05.svg"), },
        // { src: require("@/assets/logos_partner_06.svg"), },
        // { src: require("@/assets/logos_partner_07.svg"), },
        // { src: require("@/assets/logos_partner_08.svg"), },
        // { src: require("@/assets/logos_partner_09.svg"), },
        // { src: require("@/assets/logos_partner_10.svg"), },
        // { src: require("@/assets/logos_partner_11.svg"), },
        { src: require("@/assets/logos_partner_12.svg"), },
        { src: require("@/assets/logos_partner_13.svg"), },
        // { src: require("@/assets/logos_partner_14.svg"), },
        // { src: require("@/assets/logos_partner_15.svg"), },
        { src: require("@/assets/logos_partner_16.svg"), },
        { src: require("@/assets/logos_partner_17.svg"), },
        { src: require("@/assets/logos_partner_18.svg"), },
        { src: require("@/assets/logos_partner_19.svg"), },
        { src: require("@/assets/logos_partner_20.svg"), },
      ],
      cards2: [
        { src: require("@/assets/logos_customer_01.svg"), },
        { src: require("@/assets/logos_customer_02.svg"), },
        { src: require("@/assets/logos_customer_03.svg"), },
        { src: require("@/assets/logos_customer_04.svg"), },
        { src: require("@/assets/logos_customer_05.svg"), },
        { src: require("@/assets/logos_customer_06.svg"), },
        { src: require("@/assets/logos_customer_07.svg"), },
        { src: require("@/assets/logos_customer_08.svg"), },
        { src: require("@/assets/logos_customer_09.svg"), },
        { src: require("@/assets/logos_customer_10.svg"), },
        { src: require("@/assets/logos_customer_11.svg"), },
        { src: require("@/assets/logos_customer_12.svg"), },
        { src: require("@/assets/logos_customer_13.svg"), },
        { src: require("@/assets/logos_customer_14.svg"), },
        { src: require("@/assets/logos_customer_15.svg"), },
        { src: require("@/assets/logos_customer_16.svg"), },
        { src: require("@/assets/logos_customer_17.svg"), },
        { src: require("@/assets/logos_customer_18.svg"), },
        { src: require("@/assets/logos_customer_19.svg"), },
        { src: require("@/assets/logos_customer_20.svg"), },
      ],
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".customer .sub-body-title", {
      scrollTrigger: {
        trigger: ".sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".customer .h4-01", {
      scrollTrigger: {
        trigger: ".customer .h4-01",
        toggleActions: "restart none none none",
      },
      duration: .6, y: 30, opacity: 0, stagger: .3, delay: .2,
    });
    gsap.from(".customer .h4-02", {
      scrollTrigger: {
        trigger: ".customer .h4-02",
        toggleActions: "restart none none none",
      },
      duration: .6, y: 30, opacity: 0, stagger: .3, delay: .2,
    });
    gsap.from(".v-card.pa", {
      scrollTrigger: {
        trigger: ".v-card.pa",
        toggleActions: "restart none none none"
      },
      duration: 1, opacity: 0, y: 50, stagger: .05,
    });
    gsap.from(".v-card.cu", {
      scrollTrigger: {
        trigger: ".v-card.cu",
        toggleActions: "restart none none none"
      },
      duration: 1, opacity: 0, y: 50, stagger: .05,
    });
  },

  methods: {

  }

};
</script>

<style scoped>
</style>